import React, { useState, ChangeEvent, FormEvent } from 'react';


interface FormData {
  dialoutNumber: string;
  detectVoicemail: boolean;
}

const PhoneForm: React.FC = () => {
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [detectVoiceMail, setDetectVoiceMail] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string | null>(null);

  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPhoneNumber(e.target.value);
  };

  const handleCheckboxChange = () => {
    setDetectVoiceMail(!detectVoiceMail);
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    const requestBody: FormData = {
      dialoutNumber: `+${phoneNumber}`,
      detectVoicemail: detectVoiceMail,
    };

    try {
      const response = await fetch('https://wrlk8wwjm3.execute-api.us-east-1.amazonaws.com/stage/SophiaPhoneCall', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${(localStorage.getItem('idToken'))}`
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        // If the response is not OK (status code 4xx or 5xx)
        throw new Error('Failed to submit the form');
      }

      const data = await response.json();
      console.log('Response:', data);
      setModalMessage('Form submitted successfully!');
      setPhoneNumber('');
      setDetectVoiceMail(false);

      //   const data = await response.json();
      //   console.log('Response:', data);
    } catch (error) {
      console.error('Error:', error);
      setModalMessage('Failed to submit the form. Please try again.');
    }
  };

  const closeModal = () => {
    setModalMessage(null);
  };

  const formWrapperStyle = {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f4f4f4',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    color: '#333',
  };

  const formStyle = {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '30px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '400px',
    minWidth: '300px'
  };

  // const labelStyle = {
  //   fontSize: '16px',
  //   color: '#34495e',
  //   marginBottom: '8px',
  //   display: 'block',
  // };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    marginTop: '8px',
    marginBottom: '20px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '16px',
  };

  const buttonStyle = {
    backgroundColor: '#3498db',
    color: 'white',
    border: 'none',
    padding: '12px 20px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    width: '100%',
    transition: 'background-color 0.3s ease',
  };

  const buttonHoverStyle = {
    backgroundColor: '#2980b9',
  };

  const modalOverlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '1000',
  };

  const modalContentStyle: React.CSSProperties = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    width: '300px',
    textAlign: 'center',
  };

  const modalButtonStyle = {
    backgroundColor: '#3498db',
    color: 'white',
    border: 'none',
    padding: '10px',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop: '10px',
  };

  const modalButtonHoverStyle = {
    backgroundColor: '#2980b9',
  };

  // const labelStyle = {
  //   fontSize: '16px',
  //   color: '#34495e',
  //   marginBottom: '8px',
  //   display: 'flex',
  //   alignItems: 'center',
  //   gap: '10px'
  // };
  const labelStyle = {
    fontSize: '16px',
    color: '#34495e',
    marginBottom: '8px',
    display: 'block'  // Changed from flex to block
  };

  const checkboxStyle: React.CSSProperties = {
    width: 'auto',
    padding: '12px',
    marginLeft: '10px',
    cursor: 'pointer'
  };

  return (
    <div style={formWrapperStyle}>
      <div>
        <form style={formStyle} onSubmit={handleSubmit}>
          <div>
            <label style={labelStyle}>
              Phone Number:
            </label>
            <input
              type="text"
              style={inputStyle}
              value={phoneNumber}
              onChange={handlePhoneChange}
              placeholder="Enter phone number"
              required
            />
          </div>

          <div>
            <label style={labelStyle}>
              Detect Voicemail:
              <input
                type="checkbox"
                style={checkboxStyle}
                checked={detectVoiceMail}
                onChange={handleCheckboxChange}
              />
            </label>
          </div>

          <button
            style={{
              ...buttonStyle,
              ...(buttonHoverStyle ? buttonHoverStyle : {}),
            }}
            type="submit"
          >
            Submit
          </button>
        </form>

        {modalMessage && (
          <div style={modalOverlayStyle}>
            <div style={modalContentStyle}>
              <p>{modalMessage}</p>
              <button
                style={{
                  ...modalButtonStyle,
                  ...(modalButtonHoverStyle ? modalButtonHoverStyle : {}),
                }}
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhoneForm;
